import { combineReducers, Reducer }         from 'redux';
import { History }                          from 'history';
import { connectRouter, RouterState }       from 'connected-react-router';
import { auth, IAuthUser }                  from '@modules/auth/authReducer';
import { accountManagement, IAccountState } from '@modules/accountManagement/accountManagementReducer';

export interface IRootState {
  router            : RouterState;
  accountManagement : IAccountState;
  auth              : IAuthUser;
}

export type RootReducer = Reducer<IRootState>;

export const rootReducer = (history: History): RootReducer => combineReducers({
  router: connectRouter(history),
  auth,
  accountManagement,
});
